import { render, staticRenderFns } from "./HeaderNavDesktop.vue?vue&type=template&id=24342cfe&scoped=true"
import script from "./HeaderNavDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderNavDesktop.vue?vue&type=script&lang=js"
import style0 from "./HeaderNavDesktop.vue?vue&type=style&index=0&id=24342cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24342cfe",
  null
  
)

export default component.exports